import { mapState } from 'vuex';

export default {
  computed: {
    ...mapState({
      isLoggedIn: state => state.user.isLoggedIn,
    }),
  },
  methods: {
    loggedInCheck() {
      return new Promise((resolve) => {
        if (!this.isLoggedIn) {
          this.$store.dispatch('modal/showSignUp');
          resolve(false);
        } else {
          resolve(true);
        }
      });
    },
  },
};
